import { toQuery, type HttpClient } from '../client';
import type { PageResult } from '../types/result';
import type { LedgerListQuery, LedgerRow, StockListQuery, StockRow } from '../types/stock';

const BASE = '/wl/stock';

/** 库存只读查询：现存量与流水。 */
export function createStockApi(http: HttpClient) {
  return {
    list(query: StockListQuery = {}): Promise<PageResult<StockRow>> {
      return http.request<PageResult<StockRow>>({ path: BASE, query: toQuery(query) });
    },

    ledger(query: LedgerListQuery = {}): Promise<PageResult<LedgerRow>> {
      return http.request<PageResult<LedgerRow>>({ path: `${BASE}/ledger`, query: toQuery(query) });
    }
  };
}

export type StockApi = ReturnType<typeof createStockApi>;
